import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=5b64454c&"
import script from "./SearchIndex.vue?vue&type=script&lang=js&"
export * from "./SearchIndex.vue?vue&type=script&lang=js&"
import style0 from "./SearchIndex.vue?vue&type=style&index=0&id=5b64454c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports